export default __webpack_public_path__ + "static/media/location-access-page.3dcd9307.png";